import {Avatar, message} from 'antd'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React, {useContext, useRef, useState} from 'react'
import {NullAsDefault, renderIf,} from 'views/Shared'
import {renderIfElse} from "../../../Shared";
import {FaAddressCard, FaUserGraduate} from "react-icons/fa6";
import {renderMetadataMissing} from "../../../../components/DynamicFields/functions/renderMetadataMissing";
import copyToClipboard from "copy-to-clipboard";
import {IdentifierTypes} from "../../../AppLocals/appFieldTypes";
import {ItemInformation} from "../../../AppLocals/Organization/OrganizationEntity";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {IoCopyOutline} from "react-icons/io5";
import {QRComponent} from "../../../AppLocals/custom/QRComponent";
import {GoDash, GoDotFill} from "react-icons/go";
import {captureImage} from "../../../AppLocals/WoG/functions/captureImage";
import useTranslate from "../../../../modules/local/useTranslate";
import {PiDownloadFill} from "react-icons/pi";
import ResponsiveTextLabel from "../../../../components/ResponsiveTextLabel/ResponsiveTextLabel";
import {renderFromToDate} from "../../../../helpers/datetimeHelpers";
import getLinkToDetail, {getAbsoluteLinkToDetail} from "../../../../helpers/getLinkToDetail";
import getAliasName from "../../../../helpers/getAliasName";
import {Link} from "react-router-dom";

const WrapperClassStudent = ({item, index, children}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    const {student} = item ?? {}

    const {
        avatar,
        edit,
        user,
        student_idcode,
        identifier_code,
        identifier_type,
        patron_saint,
        patron_saint_name,
        fullname,
    } = student ?? {}

    return (
        <div key={index} className="p-3 flex flex-col border border-color-50 shadow-md rounded-lg hover:scale-xs custom-item-render relative">
            <div className="mb-2 pb-2 border-b border-color-100 flex items-center gap-2">
                <Avatar
                    size={35}
                    src={avatar || user?.avatar}
                    icon={<FaUserGraduate size={15} className="text-color-500"/>}
                    className="flex flex-center background-200"
                />
                <div className="flex flex-col flex-1">
                    <span className="font-bold text-base text-color-000 leading-snug">
                        <span className="mr-1 font-medium text-sm text-color-100 italic 222-222">
                            {getAliasName(student, 'patron_saint')}
                        </span>
                        {fullname}
                    </span>
                    <div className="flex items-center gap-6">
                        {
                            student_idcode && (
                            <div className="text-color-500 text-xs italic">
                                <span className="whitespace-no-wrap">
                                    {isSm ? '#' : `${t('student code')} : `}
                                </span>
                                <span
                                    onClick={() => {
                                        copyToClipboard(student_idcode)
                                        message.info(t('copied'))
                                    }}
                                    className="font-semibold text-blue-500 hover:text-blue-700 italic cursor-pointer">
                                            {student_idcode}
                                    <IoCopyOutline size={12} className="ml-1"/>
                                        </span>
                            </div>
                        )}
                        {
                            (edit === true && identifier_code) && (
                            <div className="flex items-center text-color-500 text-xs gap-1">
                                {isSm ?
                                    <FaAddressCard size={12} className="mr-1"/> :
                                    <span className="mr-1 italic whitespace-no-wrap">
                                                {`${t(_.find(IdentifierTypes, {value: identifier_type})?.label)} : `}
                                            </span>
                                }
                                <span
                                    onClick={() => {
                                        copyToClipboard(identifier_code)
                                        message.info(t('copied'))
                                    }}
                                    className="font-semibold text-blue-500 hover:text-blue-700 cursor-pointer">
                                            {identifier_code}
                                    <IoCopyOutline size={12} className="ml-1"/>
                                        </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {children}
        </div>
    )
}

export const renderCourseClassStudent = ({detail = true, renderActions = NullAsDefault, renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const {
        student,
        result_status,
        medal_awards = [],
        diocese,
        parish,
        sub_class_name,
        registered_classes = [],
        registered_subjects = [],
        role_code,
    } = item ?? {}

    const {
        contact_phone,
        contact_email,
    } = student ?? {}

    let label_status
    let color_status
    switch (result_status) {
        case 1:
            label_status = 'passed'
            color_status = 'text-green-600'
            break
        case 0:
            label_status = 'failed'
            color_status = 'text-red-600'
            break
        default:
            label_status = 'not assessed yet'
            color_status = 'text-color-300'
            break
    }

    return (
        <Translate>
            {(t) => (
                <WrapperClassStudent item={item} index={index}>
                    <div className="ml-3 flex flex-col flex-1 gap-1">
                        <ItemInformation
                            showIcon={true} primary={true}
                            className="text-xs italic" label="role"
                            value={
                                <span className={role_code === 'student_leader' ? 'font-semibold text-indigo-600' : 'font-normal text-color-200'}>
                                    {t(role_code)}
                                </span>
                            }
                        />
                        {renderIf(
                            sub_class_name,
                            <ItemInformation showIcon={true} className="text-xs italic" label="subclass title" value={sub_class_name}/>
                        )}
                        {renderIf(
                            registered_classes.length > 0,
                            <div className="space-x-1 text-xs italic">
                                <GoDotFill size={10} className="text-color-500" />
                                <span className="text-color-500 whitespace-no-wrap">
                                    {`${t('learn in the class')} : `}
                                </span>
                                {registered_classes.map((e, i) => (
                                    <Link key={i} to={getLinkToDetail} className="font-bold text-color-000 no-underline">
                                        {getTitle(e)}
                                        {i < registered_classes.length - 1 && ', '}
                                    </Link>
                                ))}
                            </div>
                        )}
                        {renderIf(
                            registered_subjects.length > 0,
                            <div className="space-x-1 text-xs italic">
                                <GoDotFill size={10} className="text-color-500" />
                                <span className="text-color-500 whitespace-no-wrap italic">
                                    {`${t('subjects registered')} :`}
                                </span>
                                {renderIfElse(
                                    registered_subjects.length > 0,
                                    registered_subjects.map((e, i) => (
                                        <span key={i} className="font-semibold text-color-100">
                                            <GoDash size={10} className="mr-1 text-color-100" />
                                            {getTitle(e)}
                                            {i < registered_subjects.length - 1 && ', '}
                                        </span>
                                    )),
                                    <span className="font-semibold text-color-100">
                                        {t('not update')}
                                    </span>
                                )}
                            </div>
                        )}
                        {renderIf(
                            medal_awards?.length > 0,
                            <div className="space-x-1 text-xs italic">
                                <GoDotFill size={10} className="text-color-500" />
                                <span className="text-color-500 whitespace-no-wrap">
                                    {`${t('certification awarded')} : `}
                                </span>
                                {medal_awards.map((e, i) => (
                                    <span key={i} className="font-bold text-primary">
                                        {getTitle(e.medal)} {i < medal_awards.length - 1 && ', '}
                                    </span>
                                ))}
                            </div>
                        )}
                        {renderIf(
                            item?.course_class?.edit,
                            renderMetadataMissing(_.get(item, 'metadata', []))
                        )}
                        {renderActions(item)}
                    </div>
                    {renderIf(
                        item?.course_class?.edit && renderContextMenu,
                        <div className="absolute top-5 right-3 contextIcon 11-11">
                            {renderContextMenu(item)}
                        </div>
                    )}
                </WrapperClassStudent>
            )}
        </Translate>
    )
}

export const renderCourseClassStudentWithSubject = ({renderActions = NullAsDefault, renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const {
        student,
        result_status,
        registered_subjects = [],
    } = item ?? {}

    let label_status
    let color_status
    switch (result_status) {
        case 1:
            label_status = 'passed'
            color_status = 'text-green-600'
            break
        case 0:
            label_status = 'failed'
            color_status = 'text-red-600'
            break
        default:
            label_status = 'not assessed yet'
            color_status = 'text-color-300'
            break
    }

    return (
        <Translate>
            {(t) => (
                <WrapperClassStudent item={item} index={index}>
                    <div className="ml-3 flex flex-col flex-1">
                        <div className="flex items-baseline gap-1 text-xs italic">
                            <GoDotFill size={10} className="text-color-400" />
                            <span className="text-color-500 whitespace-no-wrap italic">
                                {`${t('subjects registered')} :`}
                            </span>
                            {renderIfElse(
                                registered_subjects.length > 0,
                                registered_subjects.map((e, i) => (
                                    <span className="font-semibold text-color-100">
                                        {e?.title} {i < registered_subjects.length - 1 && ', '}
                                    </span>
                                )),
                                <span className="font-medium text-color-300">
                                    {t('not update')}
                                </span>
                            )}
                        </div>
                    </div>
                    {renderIf(
                        item?.course_class?.edit && renderContextMenu,
                        <div className="absolute top-5 right-0 contextIcon">
                            {renderContextMenu(item)}
                        </div>
                    )}
                </WrapperClassStudent>
            )}
        </Translate>
    )
}

export const renderStudentCard = ({course_class, renderActions = NullAsDefault, renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const {course, owner} = course_class ?? {}
    const myDivRef = useRef(null);
    const [saved, setSaved] = useState(false)

    const {
        student,
    } = item ?? {}

    const {
        avatar,
        edit,
        user,
        patron_saint_name,
        student_idcode,
        prefix_title,
        fullname,
    } = student ?? {}

    return (
        <Translate key={index}>
            {(t) => (
                <div className="custom-student-card relative">
                    <div ref={myDivRef} style={{ maxWidth: 280 }} className="h-full flex flex-col border border-color-50 rounded-lg ">
                        <div className="px-1 py-2 flex flex-col items-center border-b border-color-50">
                            <span style={{ marginBottom: 3, fontSize: 11 }} className="text-center font-bold text-green-500 italic tracking-wide leading-tight">
                                {_.get(owner, 'diocese.fullname') || _.get(owner, 'title') || `${t('diocese')} ...`}
                            </span>
                            {renderIf(
                                _.get(owner, 'parish'),
                                <ResponsiveTextLabel
                                    style={{ minHeight: 'unset' }}
                                    defaultFontSize={18}
                                    minFontSize={13}
                                    maxFontSize={19}
                                    showIcon={false}
                                    text={_.get(owner, 'parish.fullname') || `${t('parish')} ...`}
                                    className="text-center font-extrabold text-blue-700 uppercase tracking-widest leading-snug"
                                />
                            )}
                        </div>
                        <div className="px-2 py-2 md:py-4 my-auto flex flex-col items-center gap-2">
                            <QRComponent
                                key={index}
                                visible={true}
                                defaultMaxSize={140}
                                id={"student|" + student?.id}
                                encode={getAbsoluteLinkToDetail(student)}
                            />
                            <div className="flex flex-col flex-center flex-1 my-1">
                                {renderIf(
                                    patron_saint_name,
                                    <span style={{fontSize: 14 }} className="text-center font-medium text-primary tracking-widest leading-tight">
                                        {getAliasName(student, 'patron_saint')}
                                    </span>
                                )}
                                <span
                                    style={{fontSize: 16, padding: '2px 0' }}
                                    className="text-center font-extrabold text-primary tracking-wider leading-tight">
                                    {fullname}
                                </span>
                                <span className="font-medium text-2xs text-color-400 italic tracking-wider leading-tight">
                                    {`#${student_idcode}`}
                                </span>
                            </div>
                            <div style={{ fontSize: 14 }} className="text-center font-bold text-color-000 tracking-wide leading-tight">
                                {`${t('classes')} ${getTitle(course_class)}`}
                            </div>
                        </div>
                        <div className="px-1 py-2 border-t border-color-50 flex flex-col">
                                    <span className="text-center space-x-1 font-bold text-xs text-color-100 leading-snug max-lines-1">
                                        {getTitle(course_class?.course)}
                                    </span>
                            <span style={{ marginTop: 2 }} className="text-center font-medium text-2xs text-color-300 italic tracking-wide leading-tight">
                                        {renderFromToDate(course?.time_open, course?.time_close)}
                                    </span>
                        </div>
                    </div>
                    <div
                        style={{
                            height: 80,
                            background: 'linear-gradient(to top, rgb(0 0 0 / 90%) 0%, rgb(0 0 0 / 70%) 10%, rgb(0 0 0 / 30%) 30%, rgba(255, 255, 255, 0) 70%)',
                        }}
                        className="w-full p-2 flex items-end justify-center button-download absolute bottom-0 rounded-b-lg">
                        {renderIfElse(
                            saved,
                            <span className="italic text-xs text-primary-200">{t('saved')}</span>,
                            <div
                                onClick={() => {
                                    if (myDivRef && myDivRef.current) {
                                        captureImage(
                                            myDivRef.current,
                                            (blob) => {
                                                // Tạo một URL tạm thời từ blob
                                                var url = URL.createObjectURL(blob);

                                                // Tạo một thẻ a ẩn để tải ảnh xuống
                                                var a = document.createElement('a');
                                                a.style.display = 'none';
                                                a.href = url;
                                                a.download = student_idcode + '-' + fullname + '-qr.png'; // Tên tệp bạn muốn lưu

                                                // Gắn thẻ a vào document và kích hoạt sự kiện click để tải tệp
                                                document.body.appendChild(a);
                                                a.click();

                                                // Hủy URL sau khi tải xong để giải phóng bộ nhớ
                                                URL.revokeObjectURL(url);

                                                setSaved(true)
                                                // setTimeout(() => {
                                                //     setSaved(false)
                                                // }, 15000)
                                            }
                                        )
                                    }
                                }}
                                className="flex flex-center gap-x-2 text-white cursor-pointer">
                                <PiDownloadFill size={16} />
                                <span className="font-bold text-xs italic">
                                            {t('download')}
                                        </span>
                            </div>

                        )}
                    </div>
                </div>
            )}
        </Translate>
    )
}